<template>
  <v-container grid-list-md class="pa-0 ma-0">
    <v-layout row wrap>
      <v-flex xs12 sm9 md12>
        <v-tabs v-model="tab" v-if="lAction === 'view'"
        flat color="primary" dark
        grow height="40"
        fixed-tabs>
        <v-tab v-for="(tabitem, n) in tabitems" :key="n" :href="`#tab-${n}`">
          {{ tabitem }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item v-for="(tabitem, n) in tabitems" :key="n" :value="`tab-${n}`">
          <v-layout v-if="tabitem === 'Asset'" class="mt-1 pa-2" row wrap>
            <v-flex xs12 md9 mx-auto v-if="lAction === 'view'">
              <v-card-title class="title primary--text pa-2 pb-4">
                Search Asset
              </v-card-title>
              <v-card>
                <v-form ref="sForm" @submit.prevent="searchAssets()">
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs6>
                        <v-text-field
                        v-model="lSearch.asset_name"
                        label="Asset Name"
                        hide-details
                        maxlength="100"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs6>
                        <v-text-field
                        v-model="lSearch.asset_tag"
                        label="Asset Tag"
                        hide-details
                        maxlength="30"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs6>
                        <v-select
                        v-model="lSearch.asset_cat_list"
                        label="Asset Category"
                        :items="catList"
                        item-value="asset_cat_id"
                        item-text="asset_cat"
                        hide-details
                        small-chips
                        clearable
                        multiple
                        ></v-select>
                      </v-flex>
                      <v-flex xs6>
                        <v-select
                        v-model="lSearch.asset_location_list"
                        label="Location"
                        :items="assetLocation"
                        item-text="asset_location"
                        hide-details
                        small-chips
                        clearable
                        multiple
                        >
                      </v-select>
                    </v-flex>
                    <v-flex xs6>
                      <v-select
                      v-model="lSearch.amc"
                      label="AMC"
                      :items="['Under AMC', 'AMC Expired', 'No AMC']"
                      hide-details>
                    </v-select>
                  </v-flex>
                  <v-flex xs6>
                    <v-select
                    v-model="lSearch.warranty"
                    label="Warranty"
                    :items="['Under Warranty', 'Warranty Expired','No Warranty']"
                    hide-details>
                  </v-select>
                </v-flex>
                <v-flex xs6 sm4>
                  <v-checkbox
                  v-model="lSearch.is_critical"
                  label="Critical"
                  class="my-label-text-size"
                  hide-details
                  ></v-checkbox>
                </v-flex>
                <v-flex xs6 sm4>
                  <v-checkbox
                  v-model="lSearch.non_critical"
                  label="Non-critical"
                  class="my-label-text-size"
                  hide-details
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="clear">clear</v-btn>
              <v-btn color="accent" type="submit" :disabled="beingSaved">search</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-flex>

      <!-- Search results -->
      <v-flex xs12 class="mx-auto" v-if="lAction === 'view' && assetList.length > 0">
        <v-card-title class="title primary--text">
          Search Result ({{assetList.length}} Records)
        </v-card-title>
        <v-layout>
          <v-flex xs12 class="text-xs-right pa-0">
            <v-download-as
            :headers="assHead"
            :items="assetList"
            title="Asset List"
            :landscape="true"
            :fontsize="8"
            ></v-download-as>
          </v-flex>
        </v-layout>
        <v-data-table
        :headers="$vuetify.breakpoint.smAndUp?assHead:assHeadsm"
        :items="assetList"
        disable-initial-sort
        class="elevation-3 mt-3"
        :rows-per-page-items = "[10,25,50,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
        :pagination.sync="pagination"
        :search="search"
        >
        <template slot="items" slot-scope="props">
          <tr>
            <td class="pa-3" v-if="$vuetify.breakpoint.smAndUp">{{ props.item.asset_cat }}</td>
            <td class="pa-3">{{ props.item.asset_name }}</td>
            <td class="pa-3">{{ props.item.asset_qty }}</td>
            <td v-if="$vuetify.breakpoint.smAndUp" class="pa-3">{{ props.item.asset_tag }}</td>
            <td v-if="$vuetify.breakpoint.smAndUp" class="pa-3">{{ props.item.is_under_warranty }}</td>
            <td :class="(props.item.warranty_end_dt && handy.formatDBDate(props.item.warranty_end_dt)) <= today ? 'error pa-3' : 'pa-3'" v-if="$vuetify.breakpoint.smAndUp">{{ props.item.warranty_end_dt ? handy.formatDBDate(props.item.warranty_end_dt) : '' }}</td>
            <td v-if="$vuetify.breakpoint.smAndUp" class="pa-3">{{ props.item.is_under_amc }}</td>
            <td :class="(props.item.amc_due_dt && handy.formatDBDate(props.item.amc_due_dt)) <= today ? 'error pa-3' : 'pa-3'" v-if="$vuetify.breakpoint.smAndUp">{{ props.item.amc_due_dt ? handy.formatDBDate(props.item.amc_due_dt) : '' }}</td>
            <td v-if="$vuetify.breakpoint.smAndUp" class="pa-3">{{ props.item.is_critical ? 'Yes' : 'No' }}</td>
            <v-menu bottom right class="mt-2">
              <span slot="activator">
                <v-btn small icon slot="activator" class="ma-0">
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </span>
              <v-list>
                <v-list-tile @click="prepareUpdate(props.item)">
                  <v-list-tile-avatar><v-icon>edit</v-icon></v-list-tile-avatar>
                  <v-list-tile-title>Update</v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="prepareHist(props.item)">
                  <v-list-tile-avatar><v-icon>history</v-icon></v-list-tile-avatar>
                  <v-list-tile-title>Service History</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
  <v-layout v-else row wrap class="mt-1 pa-2">
    <v-flex xs12 md9 class="mx-auto" v-if="lAction === 'view'">
      <v-layout row wrap>
        <v-flex xs6>
          <v-text-field
          class="pa-0 mt-1"
          append-icon="search"
          :placeholder="$vuetify.breakpoint.smAndUp?'Search by Consumable name, Category, etc.':'Search'"
          single-line
          hide-details
          v-model="search"
          clearable
          ></v-text-field>
        </v-flex>
        <v-flex xs6>
          <v-download-as
          :headers="consHead"
          :items="consList"
          title="Consumable List"
          ></v-download-as>
        </v-flex>
      </v-layout>
      <v-data-table
      :headers="$vuetify.breakpoint.smAndUp?consHead:consHeadsm"
      :items="consList"
      hide-actions
      disable-initial-sort
      class="elevation-3 mt-3"
      :search="search"
      >
      <template slot="items" slot-scope="props">
        <tr>
          <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.cons_cat }}</td>
          <td>{{ props.item.cons_name }}</td>
          <td>{{ props.item.cons_stock_uom }}</td>
          <v-menu bottom left class="mt-2">
            <span slot="activator">
              <v-btn small icon slot="activator" class="ma-0">
                <v-icon>more_vert</v-icon>
              </v-btn>
            </span>
            <v-list>
              <v-list-tile @click="increaceStock(props.item)">
                <v-list-tile-avatar><v-icon>add</v-icon></v-list-tile-avatar>
                <v-list-tile-title>Increment Stock</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="decreaseStock(props.item)">
                <v-list-tile-avatar><v-icon>remove</v-icon></v-list-tile-avatar>
                <v-list-tile-title>Decrement Stock</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="prepareUpdateconsumable(props.item)">
                <v-list-tile-avatar><v-icon>edit</v-icon></v-list-tile-avatar>
                <v-list-tile-title>Update Consumable Details</v-list-tile-title>
              </v-list-tile>
              <v-divider></v-divider>
              <v-list-tile @click="prepareConsumableReport(props.item)">
                <v-list-tile-avatar><v-icon>report</v-icon></v-list-tile-avatar>
                <v-list-tile-title>Consumable Report</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </tr>
      </template>
    </v-data-table>
  </v-flex>
</v-layout>
</v-tab-item>

<v-tooltip top v-if="lAction === 'view'">
  <template v-slot:activator="{ on }">
    <v-btn v-on="on"
    :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:15px; left:65px;':'bottom:15px; left:410px;')"
    dark fab fixed
    color="accent"
    @click.native="tab === 'tab-0' ? prepareAsset() : prepareConsumable()">
    <v-icon>add</v-icon>
  </v-btn>
</template>
<span class="caption">Create Asset</span>
</v-tooltip>

<v-tooltip top v-if="lAction === 'view' && tab === 'tab-0'">
  <template v-slot:activator="{ on }">
    <v-btn v-on="on"
    :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:15px; left:15px;':'bottom:15px; left:360px;')"
    dark fab fixed small
    color="accent"
    @click.native="prepareUpload">
    <v-icon>file_upload</v-icon>
  </v-btn>
</template>
<span class="caption">Upload Asset</span>
</v-tooltip>

<v-tooltip top v-if="lAction === 'view' && tab === 'tab-0'">
  <template v-slot:activator="{ on }">
    <v-btn v-on="on"
    :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:15px; left:15px;':'bottom:15px; left:310px;')"
    dark fab fixed small
    color="accent"
    @click.native="prepareSerHistUpload">
    <v-icon>build</v-icon>
  </v-btn>
</template>
<span class="caption">Upload Asset Service History</span>
</v-tooltip>
</v-tabs-items>

<!--2. create / edit asset -->
<v-container v-if="lAction === 'create' || lAction === 'update'" class="pa-0" fluid full-height>
  <v-layout row wrap>
    <v-flex v-if="lAsset" xs12 sm9 md6 mx-auto class="mt-0 pt-0">
      <v-form ref="lForm" @submit.prevent="saveChanges(lAction)">
        <v-card flat>
          <v-card-text class="pt-0">
            <v-layout row wrap>
              <v-flex xs10>
                <v-select
                v-model="lAsset.asset_cat_pair"
                label="Category"
                :items="catList"
                item-value="asset_cat_id"
                item-text="asset_cat"
                return-object
                :rules="[rules.required]"
                hide-details
                ></v-select>
              </v-flex>
              <v-flex xs2>
                <v-btn icon class="grey lighten-2 mt-2" @click="prepareCategory"><v-icon>add</v-icon></v-btn>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                v-model="lAsset.asset_name"
                label="Name"
                :rules="[rules.required]"
                hide-details
                maxlength="100"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                v-model="lAsset.asset_location"
                label="Location"
                :rules="[rules.required]"
                hide-details
                maxlength="100"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                v-model="lAsset.asset_qty"
                label="Quantity"
                :rules="[rules.required]"
                hide-details
                type="number"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-select
                v-model="lAsset.asset_status"
                label="Asset status"
                :items="['Operational', 'Idle', 'Broken', 'In Repair', 'Missing', 'Decommissioned']"
                hide-details
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                v-model="lAsset.asset_tag"
                label="Asset tag"
                :rules="[rules.required]"
                hide-details
                maxlength="30"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-checkbox
                v-model="lAsset.is_critical"
                label="Critical asset"
                class="my-label-text-size"
                hide-details
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 class="pt-4">
                <span class="primary--text subheader pa-0">Additional Information (Optional)</span>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                v-model="lAsset.asset_spec"
                label="Specification"
                hide-details
                maxlength="150"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-dialog ref="dlgpurchaseDt"
                persistent v-model="dlgpurchaseDt"
                lazy max-width="290px"
                class="pt-0"
                :return-value.sync="lAsset.purchased_dt">
                <v-text-field
                slot="activator" label="Purchase/commissioned date"
                v-model="lAsset.purchased_dt" append-icon="event"
                readonly
                hide-details
                clearable
                ></v-text-field>
                <v-date-picker
                v-model="lAsset.purchased_dt"
                scrollable
                :max="today"
                first-day-of-week="1">
                <v-spacer></v-spacer>
                <v-btn flat @click="dlgpurchaseDt = false">Cancel</v-btn>
                <v-btn flat color="accent" @click="$refs.dlgpurchaseDt.save(lAsset.purchased_dt)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-flex>
          <v-flex xs6>
            <v-text-field
            v-model="lAsset.asset_value"
            label="Asset value"
            hide-details
            type="number"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-combobox
            v-model="lAsset.vendor_name"
            label="Choose vendor"
            :items= "vendors.map(rec => rec.vendor_name)"
            maxlength="50"
            hide-details
            @input="findVendor(lAsset)"
            ></v-combobox>
          </v-flex>
          <v-flex xs12 class="pt-4">
            <span class="primary--text subheader pa-0">Warranty and AMC (Optional)</span>
          </v-flex>
          <v-flex xs6>
            <v-dialog ref="dlgwarrantyStartDt"
            persistent v-model="dlgwarrantyStartDt"
            lazy max-width="290px"
            class="pt-0"
            :return-value.sync="lAsset.warranty_start_dt">
            <v-text-field
            slot="activator" label="Warranty start date"
            v-model="lAsset.warranty_start_dt" append-icon="event"
            readonly
            hide-details
            clearable
            ></v-text-field>
            <v-date-picker
            v-model="lAsset.warranty_start_dt"
            scrollable
            first-day-of-week="1">
            <v-spacer></v-spacer>
            <v-btn flat @click="dlgwarrantyStartDt = false">Cancel</v-btn>
            <v-btn flat color="accent" @click="$refs.dlgwarrantyStartDt.save(lAsset.warranty_start_dt)">OK</v-btn>
          </v-date-picker>
        </v-dialog>
      </v-flex>
      <v-flex xs6>
        <v-dialog ref="dlgwarrantyEndDt"
        persistent v-model="dlgwarrantyEndDt"
        lazy max-width="290px"
        class="pt-0"
        :return-value.sync="lAsset.warranty_end_dt">
        <v-text-field
        slot="activator" label="Warranty end date"
        v-model="lAsset.warranty_end_dt" append-icon="event"
        readonly
        hide-details
        clearable
        ></v-text-field>
        <v-date-picker
        v-model="lAsset.warranty_end_dt"
        scrollable
        first-day-of-week="1">
        <v-spacer></v-spacer>
        <v-btn flat @click="dlgwarrantyEndDt = false">Cancel</v-btn>
        <v-btn flat color="accent" @click="$refs.dlgwarrantyEndDt.save(lAsset.warranty_end_dt)">OK</v-btn>
      </v-date-picker>
    </v-dialog>
  </v-flex>
  <v-flex xs6>
    <v-dialog ref="dlgAmcStartDt"
    persistent v-model="dlgAmcStartDt"
    lazy max-width="290px"
    :return-value.sync="lAsset.amc_start_dt">
    <v-text-field
    slot="activator" label="AMC start date"
    v-model="lAsset.amc_start_dt" append-icon="event"
    readonly
    clearable
    hide-details
    ></v-text-field>
    <v-date-picker
    v-model="lAsset.amc_start_dt"
    scrollable
    first-day-of-week="1">
    <v-spacer></v-spacer>
    <v-btn flat @click="dlgAmcStartDt = false">Cancel</v-btn>
    <v-btn flat color="accent" @click="$refs.dlgAmcStartDt.save(lAsset.amc_start_dt)">OK</v-btn>
  </v-date-picker>
</v-dialog>
</v-flex>
<v-flex xs6>
  <v-dialog ref="dlgBookDt"
  persistent v-model="dlgBookDt"
  lazy max-width="290px"
  :return-value.sync="lAsset.amc_due_dt">
  <v-text-field
  slot="activator" label="AMC due date"
  v-model="lAsset.amc_due_dt" append-icon="event"
  readonly
  clearable
  hide-details
  ></v-text-field>
  <v-date-picker v-model="lAsset.amc_due_dt" scrollable
  first-day-of-week="1">
  <v-spacer></v-spacer>
  <v-btn flat @click="dlgBookDt = false">Cancel</v-btn>
  <v-btn flat color="accent" @click="$refs.dlgBookDt.save(lAsset.amc_due_dt)">OK</v-btn>
</v-date-picker>
</v-dialog>
</v-flex>
<v-flex xs6>
  <v-dialog ref="dlgserviceDt"
  persistent v-model="dlgserviceDt"
  lazy max-width="290px"
  class="pt-0"
  :return-value.sync="lAsset.next_service_due_dt">
  <v-text-field
  slot="activator" label="Next service due date"
  v-model="lAsset.next_service_due_dt" append-icon="event"
  readonly
  hide-details
  clearable
  ></v-text-field>
  <v-date-picker v-model="lAsset.next_service_due_dt" scrollable
  :min="today" first-day-of-week="1">
  <v-spacer></v-spacer>
  <v-btn flat @click="dlgserviceDt = false">Cancel</v-btn>
  <v-btn flat color="accent" @click="$refs.dlgserviceDt.save(lAsset.next_service_due_dt)">OK</v-btn>
</v-date-picker>
</v-dialog>
</v-flex>
<v-flex xs12>
  <v-textarea
  v-model="lAsset.remark"
  label="Remarks"
  hide-details
  rows="2"
  maxlength="150"
  ></v-textarea>
</v-flex>
</v-layout>
</v-card-text>
<v-card-actions>
  <v-spacer></v-spacer>
  <v-btn @click.stop="cancelChanges">Cancel</v-btn>
  <v-btn v-if="lAction === 'update'" :disabled="beingSaved" @click.native="deleteAsset(lAsset)">Delete</v-btn>
  <v-btn type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
</v-card-actions>
</v-card>
</v-form>
</v-flex>
</v-layout>
</v-container>

<!--3. manage category button -->
<v-dialog v-model="manageAssetCat" persistent max-width="500px">
  <v-card v-if="lMAction === 'view'" scrollable>
    <v-card-title class="title grey lighten-4">
      Asset Category
      <v-spacer></v-spacer>
      <v-btn small icon @click.stop="manageAssetCat = false"><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12 sm9 md12 class="mx-auto">
        <v-spacer></v-spacer>
        <v-btn color="accent" flat class="mb-0" style="float: right" @click="createManageAsset">Add New</v-btn>
        <v-data-table
        :headers="ManageAssHead"
        :items="catList"
        hide-actions
        disable-initial-sort
        class="elevation-1">
        <template slot="items" slot-scope="props">
          <tr @click="prepareEdit(props.item)">
            <td>{{ props.item.asset_cat }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
  </v-card-text>
</v-card>

<!--4. create / edit Manage Asset Category -->
<v-container v-if="lMAction === 'create' || lMAction === 'update'" class="pa-0" fluid full-height>
  <v-layout row wrap>
    <v-flex xs12>
      <v-form ref="acForm" @submit.prevent="saveAssetCat(lMAction)">
        <v-card flat>
          <v-flex xs12 class="mx-auto">
            <v-card-title class="title pb-0">
              {{ handy.startWithUpper(lMAction) }} Asset Category
            </v-card-title>
            <v-card-text>
              <v-text-field
              v-model="lCat.asset_cat"
              label="Category name"
              :rules="[rules.required]"
              hide-details
              maxlength="100"
              ></v-text-field>
            </v-card-text>
          </v-flex>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click.stop="cancelChangesCat">Cancel</v-btn>
            <v-btn flat v-if="lMAction === 'update'" :disabled="beingSaved" @click="deleteCat(lCat)">Delete</v-btn>
            <v-btn flat type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-layout>
</v-container>
</v-dialog>

<!--5. create / edit Consumable -->
<v-container v-if="lAction === 'create-cons' || lAction === 'update-cons'" class="pa-0" fluid full-height>
  <v-layout row wrap>
    <v-flex xs12 sm9 md6 mx-auto>
      <v-form ref="cForm" @submit.prevent="saveChangesConsumable(lAction)">
        <v-card flat>
          <v-card-text class="pt-0">
            <v-layout row wrap>
              <v-flex xs10>
                <v-select
                v-model="lCons.cons_cat_pair"
                label="Category"
                :items="consCatList"
                item-text="cons_cat"
                item-value="cons_cat_id"
                return-object
                :rules="[rules.required]"
                hide-details
                ></v-select>
              </v-flex>
              <v-flex xs2>
                <v-btn icon class="grey lighten-2 mt-2" @click="prepareConsCategory"><v-icon>add</v-icon></v-btn>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                v-model="lCons.cons_name"
                label="Consumable name"
                :rules="[rules.required]"
                hide-details
                maxlength="100"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 sm3 >
                <v-text-field
                :disabled = "lAction === 'update-cons'"
                v-model="lCons.cons_stock"
                label="Stock"
                :rules="[rules.required]"
                hide-details
                type="number"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 sm3>
                <v-combobox
                v-model="lCons.cons_uom"
                label="UOM"
                :rules="[rules.required]"
                :items= "['nos','ltr','kg','m','ft']"
                maxlength="25"
                hide-details
                ></v-combobox>
              </v-flex>
              <v-flex xs12 md12>
                <v-combobox
                v-model="lCons.vendor_name"
                label="Choose vendor (optional)"
                :items= "vendors.map(rec => rec.vendor_name)"
                maxlength="50"
                hide-details
                @input="findVendor(lCons)"
                ></v-combobox>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click.stop="cancelChanges">Cancel</v-btn>
            <v-btn v-if="lAction === 'update-cons'" :disabled="beingSaved" @click.native="deleteCons(lCons)">Delete</v-btn>
            <v-btn type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-layout>
</v-container>

<!--6. manage cons category button -->
<v-dialog v-model="manageConsCat" persistent max-width="500px">
  <v-card v-if="lConsAction === 'view'" scrollable>
    <v-card-title class="title grey lighten-4">
      Consumable Category
      <v-spacer></v-spacer>
      <v-btn small icon @click.stop="manageConsCat = false"><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12 sm9 md12 class="mx-auto">
        <v-spacer></v-spacer>
        <v-btn color="accent" flat class="mb-0" style="float: right" @click="createManageCons">Add New</v-btn>
        <v-data-table
        :headers="ManageConsHead"
        :items="consCatList"
        hide-actions
        disable-initial-sort
        class="elevation-1">
        <template slot="items" slot-scope="props">
          <tr @click="prepareConsEdit(props.item)">
            <td>{{ props.item.cons_cat }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
  </v-card-text>
</v-card>

<!--7. create / edit Manage Consumable Category -->
<v-container v-if="lConsAction === 'create' || lConsAction === 'update'" class="pa-0">
  <v-layout row wrap>
    <v-flex xs12>
      <v-form ref="ccForm" @submit.prevent="saveConsCat(lConsAction)">
        <v-card flat>
          <v-flex xs12 md11 class="mx-auto">
            <v-card-title class="title pb-0">
              {{ handy.startWithUpper(lConsAction) + ' Consumable Category' }}
            </v-card-title>
            <v-card-text>
              <v-text-field
              v-model="lConsCat.cons_cat"
              label="Category name"
              :rules="[rules.required]"
              hide-details
              maxlength="100"
              ></v-text-field>
            </v-card-text>
          </v-flex>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click.stop="cancelChangesConsCat">Cancel</v-btn>
            <v-btn flat v-if="lConsAction === 'update'" :disabled="beingSaved" @click="deleteConsCat(lConsCat)">Delete</v-btn>
            <v-btn flat type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-layout>
</v-container>
</v-dialog>

<!--7. service history -->
<v-dialog v-model="showHist" persistent max-width="500px">
  <v-card v-if="lSHAction === 'view'" flat>
    <v-card-title class="pa-2 subheading font-weight-bold grey lighten-4">
      {{ lAsset.asset_cat + ': ' + lAsset.asset_name }}
      <v-spacer></v-spacer>
      <v-btn small icon @click.stop="showHist = false"><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12 sm9 md12 class="mx-auto">
        <v-spacer></v-spacer>
        <v-btn color="accent" flat class="mb-0" style="float: right" @click="prepareCreateServiceHist">Add New</v-btn>
        <v-data-table
        :headers="$vuetify.breakpoint.smAndUp ? assHistHead : assHistHeadsm"
        :items="histList"
        hide-actions
        disable-initial-sort
        class="elevation-1">
        <template slot="items" slot-scope="props">
          <tr @click="prepareEditHist(props.item)">
            <td>{{ handy.formatDate(props.item.service_hist_dt) }}</td>
            <td>{{ props.item.service_hist_desc }}</td>
            <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.service_hist_cost ? handy.formatCur(props.item.service_hist_cost) : '' }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
  </v-card-text>
</v-card>

<!--8. create / edit service histroy -->
<v-container v-if="lSHAction === 'create' || lSHAction === 'update'" class="pa-0">
  <v-layout row wrap>
    <v-flex xs12>
      <v-form ref="shForm" @submit.prevent="saveServiceHistory(lSHAction)">
        <v-card flat>
          <v-card-title class="pa-1 subheading font-weight-bold grey lighten-4">
            {{ lAsset.asset_name }}
            <v-spacer></v-spacer>
            <v-btn small icon @click.stop="lSHAction = 'view'"><v-icon>close</v-icon></v-btn>
          </v-card-title>
          <v-card-title class="subheading font-weight-bold pb-0">
            {{ handy.startWithUpper(lSHAction) + ' Service History' }}
          </v-card-title>
          <v-card-text>
            <v-flex xs12 md11 class="mx-auto">
              <v-flex xs12>
                <v-dialog ref="dlgservicehistDt"
                persistent v-model="dlgservicehistDt"
                lazy max-width="290px"
                class="pt-0"
                :return-value.sync="lHist.service_hist_dt">
                <v-text-field
                slot="activator" label="Service date"
                v-model="lHist.service_hist_dt" append-icon="event"
                readonly
                hide-details
                ></v-text-field>
                <v-date-picker
                v-model="lHist.service_hist_dt"
                scrollable
                first-day-of-week="1">
                <v-spacer></v-spacer>
                <v-btn flat @click="dlgservicehistDt = false">Cancel</v-btn>
                <v-btn flat color="accent" @click="$refs.dlgservicehistDt.save(lHist.service_hist_dt)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-flex>
          <v-flex xs12>
            <v-text-field
            v-model="lHist.service_hist_desc"
            label="Service description"
            :rules="[rules.required]"
            hide-details
            maxlength="1000"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md6>
            <v-text-field
            v-model="lHist.service_hist_cost"
            label="Service cost"
            :rules="[rules.required]"
            hide-details
            type="number"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-combobox
            v-model="lHist.vendor_name"
            label="Choose vendor"
            :items= "vendors.map(rec => rec.vendor_name)"
            maxlength="50"
            hide-details
            clearable
            @input="findVendor(lHist)"
            ></v-combobox>
          </v-flex>
          <v-flex xs12 md6>
            <v-dialog ref="dlgnextservicehistDt"
            persistent v-model="dlgnextservicehistDt"
            lazy max-width="290px"
            class="pt-0"
            :return-value.sync="lHist.next_service_due_dt">
            <v-text-field
            slot="activator" label="Next service due date"
            v-model="lHist.next_service_due_dt" append-icon="event"
            readonly
            hide-details
            ></v-text-field>
            <v-date-picker v-model="lHist.next_service_due_dt" scrollable
            :min="today" first-day-of-week="1">
            <v-spacer></v-spacer>
            <v-btn flat @click="dlgnextservicehistDt = false">Cancel</v-btn>
            <v-btn flat color="accent" @click="$refs.dlgnextservicehistDt.save(lHist.next_service_due_dt)">OK</v-btn>
          </v-date-picker>
        </v-dialog>
      </v-flex>
    </v-flex>
  </v-card-text>
  <v-card-actions>
    <v-spacer></v-spacer>
    <v-btn flat @click.stop="cancelChangesServHist">Cancel</v-btn>
    <v-btn flat v-if="lSHAction === 'update'" :disabled="beingSaved" @click="deleteServiceHist(lHist)">Delete</v-btn>
    <v-btn flat type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
  </v-card-actions>
</v-card>
</v-form>
</v-flex>
</v-layout>
</v-container>
</v-dialog>

<!--9. update stock -->
<v-dialog v-model="showStock" persistent max-width="400px">
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12 mx-auto>
      <v-form ref="stForm" @submit.prevent="saveStock()">
        <v-card>
          <v-card-title class="title grey lighten-4">
            {{ lStock.cons_name }}
            <v-spacer></v-spacer>
            <v-btn small icon @click.stop="cancelStockChanges"><v-icon>close</v-icon></v-btn>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap class="pb-3">
              <v-flex xs12>
                <v-dialog ref="dlgStockpurchaseDt"
                persistent v-model="dlgStockconspurchaseDt"
                lazy max-width="290px"
                class="pt-0"
                :return-value.sync="lStock.purchase_or_cons_dt">
                <v-text-field
                slot="activator" :label="stockLabel"
                v-model="lStock.purchase_or_cons_dt" append-icon="event"
                readonly
                hide-details
                ></v-text-field>
                <v-date-picker v-model="lStock.purchase_or_cons_dt" scrollable
                first-day-of-week="1">
                <v-spacer></v-spacer>
                <v-btn flat @click="dlgStockconspurchaseDt = false">Cancel</v-btn>
                <v-btn flat color="accent" @click="$refs.dlgStockpurchaseDt.save(lStock.purchase_or_cons_dt)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-flex>
          <v-flex xs6>
            <v-text-field
            v-model="lStock.stock_qty"
            label="Quantity"
            :rules="[rules.required]"
            hide-details
            type="number"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 class="mt-4 subheading">
            <span>{{lCons.cons_uom}}</span>
          </v-flex>
          <v-flex xs12>
            <v-text-field
            v-model="lStock.stock_desc"
            label="Consumable Location"
            hide-details
            maxlength="200"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-card dark color="info">
          <v-card-text class="pa-1">
            <div class="text-xs-center">
              <div class="subheading">
                Closing Stock: <span class="yellow--text title">{{ newStock + ' ' + lCons.cons_uom }}</span>
              </div>
              <div>
                [ Prev. Stock {{ lCons.cons_stock_uom + (lStock.stock_action === 'I'? ' +' : ' -') }} New Stock {{ (lStock.stock_qty ? lStock.stock_qty + ' ' : '0 ') + lCons.cons_uom }} ]
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-btn flat @click.stop="cancelStockChanges">Cancel</v-btn>
        <v-btn flat type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</v-flex>
</v-container>
</v-dialog>

<!-- upload files -->
<v-container v-if="lAction === 'upload'" class="pa-0" grid-list-md>
  <v-layout row wrap>
    <v-flex xs12>
      <v-card flat>
        <v-card-title class="title pa-0 pl-3">
          Upload Asset List
        </v-card-title>
        <div class="mt-3 text-xs-center primary--text" style="font-family: 'Satisfy', cursive; font-size:200%; font-weight:normal">In just 4 steps</div>
        <v-card-text class="subheading">
          <v-layout row wrap>
            <v-flex xs12>
              <v-chip small disabled outline class="primary--text">Step 1</v-chip>
              <span>Download template</span>

              <span style="float:right;">
                <form method="get" action="../static/files/Smartility_Asset_List_Template.xlsx">
                  <v-btn type="submit" class="mt-0 mb-0" small><v-icon>file_download</v-icon></v-btn>
                </form>
              </span>
            </v-flex>
            <v-flex xs12>
              <v-chip small disabled outline class="primary--text">Step 2</v-chip>
              <span>Fill-in details as guided in template</span>
            </v-flex>
            <v-flex xs12>
              <v-chip small disabled outline class="primary--text">Step 3</v-chip>
              <span>Save as CSV <span class="caption">(Comma delimited)</span><br />
              <span class="caption grey--text pl-4 ml-4">
                <span class="ml-4">Go with OK/Yes when prompted while saving</span>
              </span>
            </span>
          </v-flex>
          <v-flex xs12>
            <v-chip small disabled outline class="primary--text">Step 4</v-chip>
            <span>Upload the CSV file</span>
            <span style="float:right;"><v-btn small class="mt-0 mb-0 accent" @click.native="promptUpload"><v-icon>file_upload</v-icon></v-btn></span>
            <input style="display:none" ref="ipFile" type="file" accept=".csv" @change="validateFile()"/>
          </v-flex>
          <v-flex xs12>
            <div class="mt-3 text-xs-center primary--text" style="font-family: 'Satisfy', cursive; font-size:200%; font-weight:normal">Uniservice takes care of rest</div>
          </v-flex>
          <v-flex xs12>
            <v-chip small disabled outline class="primary--text">Step 4</v-chip>
            <span>Validate your information</span>
          </v-flex>
          <v-flex xs12>
            <v-chip small disabled outline class="primary--text">Step 5</v-chip>
            <span>Create Asset List</span>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions class="pt-0 pr-4">
        <v-spacer></v-spacer>
        <v-btn @click.native="cancelChanges">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-flex>
</v-layout>
</v-container>

<!-- validate uploaded files-->
<v-container v-if="lAction === 'validate'" class="pa-0" grid-list-md>
  <v-layout row wrap>
    <v-flex xs12>
      <v-card flat>
        <v-card-title class="title pa-0 pl-3">
          Upload Asset List
        </v-card-title>
        <v-card-text class="text-xs-center pl-2 pr-2">
          <v-layout row wrap>
            <v-flex xs12 md9 mx-auto>
              <v-layout row wrap>
                <v-flex xs12 class="info--text mb-2">
                  <span v-if="validateInProgress">Loading and validating the file...</span>
                  <span v-if="validFile && !validateInProgress">File validation is successfull <v-icon class="success--text">check</v-icon></span>
                  <span v-if="!validFile">File validation is failed <v-icon class="error--text">close</v-icon></span>
                  <span v-if="!validFile && headerIssue" class="error--text"><br />Invalid column headers, please ensure names and count are matching as per the template</span>
                  <span v-if="!validFile && !headerIssue" class="error--text"><br />One or more invalid records, review the table below.<br/>Click on the errored row to know more info.</span>
                  <span v-if="!totFail && !loadInProgress">Asset list upload was successfull<v-icon class="success--text">check</v-icon></span>
                  <span v-if="!totLoaded && totFail && !loadInProgress"><br />Asset list upload has failed<v-icon class="error--text">close</v-icon></span>
                  <span v-if="totLoaded && totFail && !loadInProgress"><br />Asset list upload partially failed<v-icon class="warning--text">close</v-icon></span>
                  <span v-if="totFail && !loadInProgress" class="error--text"><br />One or more failed records, review the table below.<br/>Click on the errored row to know more info.</span>
                </v-flex>
                <v-flex xs4 v-if="totRecs">
                  <v-progress-circular color="info"
                  :value="readyForLoad ? 100 : (recsLoaded.length/totRecs*100)"
                  :size="50" :width="7">
                  {{ readyForLoad ? totValid : recsLoaded.length }}
                </v-progress-circular>
                <br/><div class="caption grey--text">Records</div>
              </v-flex>
              <v-flex xs4 v-if="totRecs">
                <v-progress-circular color="success"
                :value="(totValid/totRecs*100)"
                :size="50" :width="7">
                {{ readyForLoad ? totLoaded : totValid }}
              </v-progress-circular>
              <br/><div class="caption grey--text">{{ readyForLoad ? 'Loaded' : 'Valid' }}</div>
            </v-flex>
            <v-flex xs4 v-if="totRecs">
              <v-progress-circular color="error"
              :value="(totInvalid/totRecs*100)"
              :size="50" :width="7">
              {{ readyForLoad ? totFail : totInvalid }}
            </v-progress-circular>
            <br/><div class="caption grey--text">{{ readyForLoad ? 'Failed' : 'Invalid' }}</div>
          </v-flex>
          <v-flex xs12>
            <v-btn small @click.native="lAction='upload'">Cancel</v-btn>
            <v-btn v-if="totValid > 0" small class="accent" @click.native="uploadAsset" :disabled="beingSaved">Process the valid records</v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12 class="mt-2">
        <v-data-table
        :headers="loadHeadSm"
        :items="recsLoaded"
        hide-actions
        class="elevation-3 text-xs-left"
        disable-initial-sort
        >
        <template slot="items" slot-scope="props">
          <tr :class="(props.item.error ? (props.item.load_status === 'Failed' ? 'error':'error--text') : (props.item.load_status === 'Loaded' ? 'success' : ''))" @click="props.item.error ? showError(props.item.error) : ''">
            <td>{{ props.item.asset_cat }}</td>
            <td>{{ props.item.asset_name }}</td>
            <td>{{ props.item.asset_location }}</td>
            <td>{{ props.item.asset_qty }}</td>
            <td>{{ props.item.asset_status }}</td>
            <td>{{ props.item.is_critical }}</td>
            <td>{{ props.item.asset_tag }}</td>
            <td>{{ props.item.asset_spec }}</td>
            <td>{{ props.item.asset_value }}</td>
            <td>{{ props.item.purchased_dt }}</td>
            <td>{{ props.item.warranty_start_dt }}</td>
            <td>{{ props.item.warranty_end_dt }}</td>
            <td>{{ props.item.amc_start_dt }}</td>
            <td>{{ props.item.amc_due_dt }}</td>
            <td>{{ props.item.vendor_name }}</td>
            <td>{{ props.item.next_service_due_dt }}</td>
            <td>{{ props.item.remark }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</v-card-text>
<v-card-actions class="pt-0" v-if="false">
  <v-spacer></v-spacer>
  <v-btn flat @click.native="cancelChanges">Cancel</v-btn>
</v-card-actions>
</v-card>
</v-flex>
</v-layout>
</v-container>

<!-- Upload Service History -->
<v-container v-if="lAction === 'upload-serviceHistory'" class="pa-0" grid-list-md>
  <v-layout row wrap>
    <v-flex xs12>
      <v-card flat>
        <v-card-title class="title pa-0 pl-3">
          Upload Asset Service History
        </v-card-title>
        <div class="mt-3 text-xs-center primary--text" style="font-family: 'Satisfy', cursive; font-size:200%; font-weight:normal">In just 5 steps</div>
        <v-card-text class="subheading">
          <v-layout row wrap>
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs3>
                  <v-chip small disabled outline class="primary--text">Step 1</v-chip>
                  <span>Select assets</span>
                </v-flex>
                <v-flex xs3 class="pt-0">
                  <v-select
                  v-model="lUpload.assetTypes"
                  label="Asset Type"
                  :items="['Critical', 'Non-Critical', 'All']"
                  hide-details
                  small-chips
                  clearable
                  multiple
                  class="pt-0"
                  @input="searchAssets()"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-chip small disabled outline class="primary--text">Step 2</v-chip>
              <span>Download template as csv</span>
              <span style="float:right;">
                <v-download-as
                :headers="assetServiceHead"
                :items="assetList"
                title="Asset Service History"
                :landscape="true"
                :fontsize="8"
                ></v-download-as>
              </span>
            </v-flex>
            <v-flex xs12>
              <v-chip small disabled outline class="primary--text">Step 3</v-chip>
              <span>Fill-in details as guided in template </span>
              <div class="caption grey--text pl-4 ml-4">
                <span class="ml-4">(Tip: <a style="text-decoration: underline;" @click="loadVendorList">Click here</a> to see the list of vendors )</span>
              </div>
            </v-flex>
            <v-flex xs12>
              <v-chip small disabled outline class="primary--text">Step 4</v-chip>
              <span>Save as CSV <span class="caption">(Comma delimited)</span><br />
              <span class="caption grey--text pl-4 ml-4">
                <span class="ml-4">Go with OK/Yes when prompted while saving</span>
              </span>
            </span>
          </v-flex>
          <v-flex xs12>
            <v-chip small disabled outline class="primary--text">Step 5</v-chip>
            <span>Upload the CSV file</span>
            <span style="float:right;"><v-btn small class="mt-0 mb-0 accent" @click.native="promptUpload"><v-icon>file_upload</v-icon></v-btn></span>
            <input style="display:none" ref="ipFile" type="file" accept=".csv" @change="validateServiceHistFile()"/>
          </v-flex>
          <v-flex xs12>
            <div class="mt-3 text-xs-center primary--text" style="font-family: 'Satisfy', cursive; font-size:200%; font-weight:normal">Uniservice takes care of rest</div>
          </v-flex>
          <v-flex xs12>
            <v-chip small disabled outline class="primary--text">Step 6</v-chip>
            <span>Validate your information</span>
          </v-flex>
          <v-flex xs12>
            <v-chip small disabled outline class="primary--text">Step 7</v-chip>
            <span>Create service history</span>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions class="pt-0 pr-4">
        <v-spacer></v-spacer>
        <v-btn @click.native="cancelChanges">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-flex>
</v-layout>
</v-container>

<!-- validate service history uploaded files-->
<v-container v-if="lAction === 'validate-serviceHistory'" class="pa-0" grid-list-md>
  <v-layout row wrap>
    <v-flex xs12>
      <v-card flat>
        <v-card-title class="title pa-0 pl-3">
          Upload Asset Service History List
        </v-card-title>
        <v-card-text class="text-xs-center pl-2 pr-2">
          <v-layout row wrap>
            <v-flex xs12 md9 mx-auto>
              <v-layout row wrap>
                <v-flex xs12 class="info--text mb-2">
                  <span v-if="validateInProgress">Loading and validating the file...</span>
                  <span v-if="validFile && !validateInProgress">File validation is successfull <v-icon class="success--text">check</v-icon></span>
                  <span v-if="!validFile">File validation is failed <v-icon class="error--text">close</v-icon></span>
                  <span v-if="!validFile && headerIssue" class="error--text"><br />Invalid column headers, please ensure names and count are matching as per the template</span>
                  <span v-if="!validFile && !headerIssue" class="error--text"><br />One or more invalid records, review the table below.<br/>Click on the errored row to know more info.</span>
                  <span v-if="!totFail && !loadInProgress">Asset list upload was successfull<v-icon class="success--text">check</v-icon></span>
                  <span v-if="!totLoaded && totFail && !loadInProgress"><br />Asset Service History list upload has failed<v-icon class="error--text">close</v-icon></span>
                  <span v-if="totLoaded && totFail && !loadInProgress"><br />Asset Service History list upload partially failed<v-icon class="warning--text">close</v-icon></span>
                  <span v-if="totFail && !loadInProgress" class="error--text"><br />One or more failed records, review the table below.<br/>Click on the errored row to know more info.</span>
                </v-flex>
                <v-flex xs4 v-if="totRecs">
                  <v-progress-circular color="info"
                  :value="readyForLoad ? 100 : (recSerHistLoaded.length/totRecs*100)"
                  :size="50" :width="7">
                  {{ readyForLoad ? totValid : recSerHistLoaded.length }}
                </v-progress-circular>
                <br/><div class="caption grey--text">Records</div>
              </v-flex>
              <v-flex xs4 v-if="totRecs">
                <v-progress-circular color="success"
                :value="(totValid/totRecs*100)"
                :size="50" :width="7">
                {{ readyForLoad ? totLoaded : totValid }}
              </v-progress-circular>
              <br/><div class="caption grey--text">{{ readyForLoad ? 'Loaded' : 'Valid' }}</div>
            </v-flex>
            <v-flex xs4 v-if="totRecs">
              <v-progress-circular color="error"
              :value="(totInvalid/totRecs*100)"
              :size="50" :width="7">
              {{ readyForLoad ? totFail : totInvalid }}
            </v-progress-circular>
            <br/><div class="caption grey--text">{{ readyForLoad ? 'Failed' : 'Invalid' }}</div>
          </v-flex>
          <v-flex xs12>
            <v-btn small @click.native="lAction='upload-serviceHistory'">Cancel</v-btn>
            <v-btn v-if="totValid > 0" small class="accent" @click.native="uploadAssetServiceHist" :disabled="beingSaved || totFail > 0">Process the valid records</v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12 class="mt-2">
        <v-data-table
        :headers="assetServiceHead"
        :items="recSerHistLoaded"
        hide-actions
        class="elevation-3 text-xs-left"
        disable-initial-sort
        >
        <template slot="items" slot-scope="props">
          <tr :class="(props.item.error ? (props.item.load_status === 'Failed' ? 'error':'error--text') : (props.item.load_status === 'Loaded' ? 'success' : ''))" @click="props.item.error ? showError(props.item.error) : ''">
            <td>{{ props.item.asset_id }}</td>
            <td>{{ props.item.asset_cat }}</td>
            <td>{{ props.item.asset_name }}</td>
            <td>{{ props.item.asset_tag }}</td>
            <td>{{ props.item.service_hist_dt }}</td>
            <td>{{ props.item.service_hist_desc }}</td>
            <td>{{ props.item.service_hist_cost }}</td>
            <td>{{ props.item.vendor_id }}</td>
            <td>{{ props.item.next_service_due_dt }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</v-card-text>
<v-card-actions class="pt-0" v-if="false">
  <v-spacer></v-spacer>
  <v-btn flat @click.native="cancelChanges">Cancel</v-btn>
</v-card-actions>
</v-card>
</v-flex>
</v-layout>
</v-container>

<!-- Show consumable report -->
<v-dialog v-model="showConsReport" persistent max-width="1100px">
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-card flat>
      <v-card-title class="py-0 title grey lighten-4">
        {{ consReport.cons_name }}
        <v-spacer></v-spacer>
        <v-btn small icon @click="showConsReport = false"><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="pa-0">
        <v-card flat>
          <v-card-title class="pa-2">
            <v-flex xs6 class="text-xs-center">
              <v-layout row wrap>
                <v-flex xs5>
                  <v-dialog ref="fromDt"
                  persistent v-model="fromDt"
                  lazy max-width="290px"
                  :return-value.sync="consReport.from_dt"
                  >
                  <v-text-field
                  slot="activator" label="From Date"
                  v-model="consReport.from_dt"
                  append-icon="event"
                  readonly clearable
                  hide-details
                  required
                  ></v-text-field>
                  <v-date-picker v-model="consReport.from_dt" scrollable
                  first-day-of-week="1"
                  >
                  <v-spacer></v-spacer>
                  <v-btn flat @click="fromDt = false">Cancel</v-btn>
                  <v-btn flat color="accent" @click="$refs.fromDt.save(consReport.from_dt)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-flex>
            <v-flex xs5>
              <v-dialog ref="toDt"
              persistent v-model="toDt"
              lazy max-width="290px"
              :return-value.sync="consReport.to_dt"
              >
              <v-text-field
              slot="activator" label="To Date"
              v-model="consReport.to_dt"
              append-icon="event"
              readonly clearable
              hide-details
              required
              ></v-text-field>
              <v-date-picker v-model="consReport.to_dt" scrollable
              first-day-of-week="1"
              >
              <v-spacer></v-spacer>
              <v-btn flat @click="fromDt = false">Cancel</v-btn>
              <v-btn flat color="accent" @click="$refs.toDt.save(consReport.to_dt)">OK</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-flex>
        <v-flex xs2 class="text-xs-center">
          <v-btn small fab class="accent" @click.native="prepareConsumableReport(consReport)">Go</v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs6>
      <v-download-as
      :headers="repHead"
      :items="downloadConsReport"
      title="Consumable Report"
      :subtitle="consReport.cons_name + ' (' + handy.formatDate(consReport.from_dt) + ' to ' + handy.formatDate(consReport.to_dt) + ')'"
      :fontsize="8"
      :legend="'Net closing stock: ' + (consReport.netStock ? consReport.netStock : 0)"
      :landscape="true"
      ></v-download-as>
    </v-flex>
  </v-card-title>
  <v-card-text class="pa-0">
    <v-flex xs12 class="px-2 pt-0 pb-2">
      <v-data-table
      :headers="repHead"
      :items="downloadConsReport"
      hide-actions
      class="elevation-2"
      >
      <template slot="items" slot-scope="props">
        <tr v-if="props.item.modify_by === 'Closing Stock'" :style="'font-weight: bold; color:#00000; background-color: #D5D8D0'">
          <td style="text-align: left; font-weight: bold; font-size: 13px">{{ props.item.cons_name }}</td>
          <td>{{ props.item.purchase_or_cons_dt != '-' ? handy.formatDate(props.item.purchase_or_cons_dt) : '' }}</td>
          <td>{{ props.item.cust_name }}</td>
          <td>{{ props.item.previous_stock }}</td>
          <td>{{ props.item.pur_stock_qty }}</td>
          <td>{{ props.item.cons_stock_qty }}</td>
          <td style="text-align: left; font-weight: bold; font-size: 13px">{{ props.item.cons_stock }}</td>
          <td>{{ props.item.stock_desc }}</td>
        </tr>
        <tr v-else>
          <td>{{ props.item.cons_name }}</td>
          <td>{{ props.item.purchase_or_cons_dt != '-' ? handy.formatDate(props.item.purchase_or_cons_dt) : '' }}</td>
          <td>{{ props.item.cust_name }}</td>
          <td>{{ props.item.previous_stock }}</td>
          <td>{{ props.item.pur_stock_qty }}</td>
          <td>{{ props.item.cons_stock_qty }}</td>
          <td>{{ props.item.cons_stock }}</td>
          <td>{{ props.item.stock_desc }}</td>
        </tr>
      </template>
      <!-- <template slot="footer">
        <tr>
          <td class="subheading" colspan="100%">
            <strong>{{ 'Net closing stock: ' + (consReport.netStock ? consReport.netStock : 0) }}</strong>
          </td>
        </tr>
      </template> -->
    </v-data-table>
  </v-flex>
</v-card-text>
</v-card>
</v-card-text>
</v-card>
</v-container>
</v-dialog>

<!-- show vendor list -->
<v-dialog v-model="showVendorList" scrollable persistent max-width="400px">
  <v-card>
    <v-card-title class="pa-1 ml-1 grey lighten-4 title">
      Choose vendor list
      <v-spacer></v-spacer>
      <v-btn icon small @click.stop="showVendorList = false"><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-card-text>
      <v-data-table
      :headers="vendorHeader"
      :items="vendors"
      hide-actions
      class="elevation-2"
      >
      <template slot="items" slot-scope="props">
        <tr>
          <td>{{ props.item.vendor_id }}</td>
          <td>{{ props.item.vendor_name }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
</v-card>
</v-dialog>

<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar"
:timeout="4000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>
</v-flex>
</v-layout>
</v-container>
</template>

<script>
import handy from '@/utils/handy'
import config from '@/config/app-cfg'
import VDownloadAs from './VDownloadAs.vue'

export default {
  components:
  {
    'v-download-as': VDownloadAs
  },
  data () {
    return {
      lAction: '',
      lMAction: '',
      lConsAction: '',
      lSHAction: '',
      tab: 'tab-0',
      lAsset: '',
      lCons: '',
      search: '',
      lStock: '',
      stockLabel: '',
      assetList: [],
      consList: [],
      vendors: [],
      catList: [],
      consCatList: [],
      histList: [],
      lCat: [],
      lConsCat: [],
      lHist: [],
      sbarMsg: '',
      sbar: false,
      sbarCol: 'error',
      beingSaved: false,
      dlgBookDt: false,
      dlgAmcStartDt: false,
      dlgserviceDt: false,
      dlgpurchaseDt: false,
      dlgwarrantyStartDt: false,
      dlgwarrantyEndDt: false,
      dlgservicehistDt: false,
      dlgnextservicehistDt: false,
      dlgStockconspurchaseDt: false,
      manageAssetCat: false,
      manageConsCat: false,
      showHist: false,
      showStock: false,
      handy: handy,
      rules: handy.rules,
      tabitems: ['Asset', 'Consumable'],
      assHead: [
        { text: 'Category', value: 'asset_cat', class: 'pa-3' },
        { text: 'Asset Name', value: 'asset_name', class: 'pa-3' },
        { text: 'Quantity', value: 'asset_qty', class: 'pa-3' },
        { text: 'Asset Tag', value: 'asset_tag', class: 'pa-3' },
        { text: 'Warranty?', value: 'is_under_warranty', class: 'pa-3' },
        { text: 'Warranty Ends On', value: 'warranty_end_dt', class: 'pa-3' },
        { text: 'AMC?', value: 'is_under_amc', class: 'pa-3' },
        { text: 'AMC Due On', value: 'amc_due_dt', class: 'pa-3' },
        { text: 'Is Critical?', value: 'is_critical', class: 'pa-3' },
        { text: '', sortable: false, value: 'action', class: 'pa-3' }
      ],
      assHeadsm: [
        { text: 'Asset Name', value: 'asset_name' },
        { text: 'Quantity', value: 'asset_qty' },
        { text: '', sortable: false, value: 'action' }
      ],
      ManageAssHead: [
        { text: 'Category Name', value: 'asset_name' }
      ],
      ManageConsHead: [
        { text: 'Category Name', value: 'cons_cat' }
      ],
      consHead: [
        { text: 'Category', value: 'cons_cat' },
        { text: 'Consumable Name', value: 'cons_name' },
        { text: 'Stock', value: 'cons_stock_uom' },
        { text: '', sortable: false, value: 'action' }
      ],
      consHeadsm: [
        { text: 'Consumable Name', value: 'cons_name' },
        { text: 'Stock', value: 'cons_stock_uom' },
        { text: '', sortable: false, value: 'action' }
      ],
      assHistHead: [
        { text: 'Date', value: 'service_hist_dt' },
        { text: 'Description', value: 'service_hist_desc' },
        { text: 'Cost', value: 'service_hist_cost' }
      ],
      assHistHeadsm: [
        { text: 'Date', value: 'service_hist_dt' },
        { text: 'Description', value: 'service_hist_desc' }
      ],
      loadHeadSm: [
        { text: 'Asset Category', value: 'asset_cat' },
        { text: 'Asset Name', value: 'asset_name' },
        { text: 'Location', value: 'asset_location' },
        { text: 'Quantity', value: 'asset_qty' },
        { text: 'Status', value: 'asset_status' },
        { text: 'Critical?', value: 'is_critical' },
        { text: 'Asset Tag No.', value: 'asset_tag' },
        { text: 'Make/Model/Specification', value: 'asset_spec' },
        { text: 'Asset Value', value: 'asset_value' },
        { text: 'Purchased/Commissioned Date', value: 'purchased_dt' },
        { text: 'Warranty Start Date', value: 'warranty_start_dt' },
        { text: 'Warranty End Date', value: 'warranty_end_dt' },
        { text: 'AMC Start Date', value: 'amc_start_dt' },
        { text: 'AMC End Date', value: 'amc_due_dt' },
        { text: 'Vendor', value: 'vendor_id' },
        { text: 'Next Service Due Date', value: 'next_service_due_dt' },
        { text: 'Remark', value: 'remark' }
      ],
      // file upload
      validateInProgress: true,
      readyForLoad: false,
      loadInProgress: true,
      validFile: true,
      headerIssue: false,
      fileError: false,
      totRecs: 0,
      recsLoaded: [],
      recSerHistLoaded: [],
      totValid: 0,
      totInvalid: 0,
      totLoaded: 0,
      totFail: 0,
      reqHeaders: ['Asset Category', 'Asset Name', 'Location', 'Quantity', 'Status', 'Critical?', 'Asset Tag No.', 'Make/Model/Specification', 'Asset Value', 'Purchased/Commissioned Date', 'Warranty Start Date', 'Warranty End Date', 'AMC Start Date', 'AMC End Date', 'Vendor', 'Next Service Due Date', 'Remark'],
      colNames: [
        {col_name: 'asset_cat', is_required: true},
        {col_name: 'asset_name', is_required: true},
        {col_name: 'asset_location', is_required: true},
        {col_name: 'asset_qty', is_required: true},
        {col_name: 'asset_status', is_required: true},
        {col_name: 'is_critical', is_required: true},
        {col_name: 'asset_tag', is_required: true},
        {col_name: 'asset_spec', is_required: false},
        {col_name: 'asset_value', is_required: false},
        {col_name: 'purchased_dt', is_required: false},
        {col_name: 'warranty_start_dt', is_required: false},
        {col_name: 'warranty_end_dt', is_required: false},
        {col_name: 'amc_start_dt', is_required: false},
        {col_name: 'amc_due_dt', is_required: false},
        {col_name: 'vendor_name', is_required: false},
        {col_name: 'next_service_due_dt', is_required: false},
        {col_name: 'remark', is_required: false}
      ],
      pagination: { rowsPerPage: 25 },
      lSearch: {},
      assetLocation: [],
      showConsReport: false,
      consReport: [],
      repHead: [
        { text: 'Consumable Name', value: 'cons_name', sortable: false },
        { text: 'Date', value: 'purchase_or_cons_dt', sortable: false },
        { text: 'Modified by', value: 'cust_name', sortable: false },
        { text: 'Opening stock', value: 'previous_stock', class: 'pa-2', sortable: false },
        { text: 'Purchased stock', value: 'pur_stock_qty', class: 'pa-2', sortable: false },
        { text: 'Consumed stock', value: 'cons_stock_qty', class: 'pa-2', sortable: false },
        { text: 'Closing balance', value: 'cons_stock', class: 'pa-2', sortable: false },
        { text: 'Consumable Location', value: 'stock_desc', class: 'pa-2', sortable: false }
      ],
      downloadConsReport: [],
      fromDt: false,
      toDt: false,
      lUpload: {},
      assetServiceHead: [
        { text: 'Asset id', value: 'asset_id', class: 'pa-3' },
        { text: 'Category', value: 'asset_cat', class: 'pa-3' },
        { text: 'Asset name', value: 'asset_name', class: 'pa-3' },
        { text: 'Asset tag', value: 'asset_tag', class: 'pa-3' },
        { text: 'Service date', value: 'service_hist_dt', class: 'pa-3' },
        { text: 'Service description', value: 'service_hist_desc', class: 'pa-3' },
        { text: 'Service cost', value: 'service_hist_cost', class: 'pa-3' },
        { text: 'Vendor id', value: 'vendor_id', class: 'pa-3' },
        { text: 'Next service due date', value: 'next_service_due_dt', class: 'pa-3' }
      ],
      reqSerHistHeaders: ['Asset id', 'Category', 'Asset name', 'Asset tag', 'Service date', 'Service description', 'Service cost', 'Vendor id', 'Next service due date'],
      colSerHistNames: [
        {col_name: 'asset_id', is_required: true},
        {col_name: 'asset_cat', is_required: true},
        {col_name: 'asset_name', is_required: true},
        {col_name: 'asset_tag', is_required: true},
        {col_name: 'service_hist_dt', is_required: true},
        {col_name: 'service_hist_desc', is_required: true},
        {col_name: 'service_hist_cost', is_required: false},
        {col_name: 'vendor_id', is_required: true},
        {col_name: 'next_service_due_dt', is_required: false}
      ],
      showVendorList: false,
      vendorHeader: [
        { text: 'Vendor id', value: 'vendor_id', class: 'pa-3' },
        { text: 'Vendor name', value: 'vendor_name', class: 'pa-3' }
      ],
      consIds: [],
      consDet: []
    }
  },
  computed: {
    today: function () {
      return handy.formatDBDate(Date())
    },
    curTime: function () {
      return handy.formatDBDateTime(Date())
    },
    newStock: function () {
      if (this.lStock.stock_action === 'I') {
        return Number(this.lCons.cons_stock) + Number(this.lStock.stock_qty)
      } else {
        return Number(this.lCons.cons_stock) - Number(this.lStock.stock_qty)
      }
    }
  },
  created () {
    // TBD - have to be loaded on demand
    this.loadVendor()
    this.loadCategory()
  },
  mounted () {
    this.lAction = 'view'
    this.lMAction = 'view'
    this.loadAssetLocation()
    this.loadConsumable()
  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    getEmptyAsset () {
      var emptyAsset = {
        comm_id: config.COMM_ID,
        asset_cat_pair: '',
        asset_name: '',
        asset_location: '',
        asset_qty: '',
        asset_status: 'Operational',
        is_critical: false,
        asset_tag: ''
      }
      return emptyAsset
    },
    prepareAsset () {
      this.lAsset = this.getEmptyAsset()
      this.loadVendor()
      this.loadCategory()
      this.lAction = 'create'
    },
    loadCategory () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      // available Category
      this.axios.get(config.API_URL + '/getAssetCategoryByCommId/', qry)
      .then(response => {
        this.catList = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    loadVendor () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.vendors = []
      this.axios.get(config.API_URL + '/getVendorByCommId/', qry)
      .then(response => {
        this.vendors = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    searchAssets () {
      var qry = {
        params: {
        }
      }
      if (this.lAction !== 'upload-serviceHistory') {
        if (!this.lSearch.asset_name && !this.lSearch.asset_tag && (!this.lSearch.asset_location_list || !this.lSearch.asset_location_list.length) && (!this.lSearch.asset_cat_list || !this.lSearch.asset_cat_list.length) && (!this.lSearch.amc || !this.lSearch.amc.length) && (!this.lSearch.warranty || !this.lSearch.warranty.length) && !this.lSearch.is_critical && !this.lSearch.non_critical) {
          this.msg('Please enter any search criteria', 0)
          return
        }
        qry.params = this.lSearch
      } else {
        if (this.lUpload.assetTypes.includes('Critical')) {
          this.lUpload.is_critical = true
        } else {
          this.lUpload.is_critical = false
        }
        if (this.lUpload.assetTypes.includes('Non-Critical')) {
          this.lUpload.non_critical = true
        } else {
          this.lUpload.non_critical = false
        }
        if (this.lUpload.assetTypes.includes('All')) {
          this.lUpload.is_critical = true
          this.lUpload.non_critical = true
        }
        qry.params = this.lUpload
      }
      qry.params.comm_id = config.COMM_ID
      this.beingSaved = true
      this.axios.get(config.API_URL + '/getAssetListByCommId/', qry)
      .then(response => {
        this.assetList = response.data
        this.assetList.forEach(rec => {
          rec.service_hist_dt = null
          rec.next_service_due_dt = rec.next_service_due_dt ? handy.formatDBDate(rec.next_service_due_dt) : null
        })
        if (!this.assetList.length) {
          this.msg('No records found for given search criteria', 0)
        }
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err)
        this.assetList = []
        this.beingSaved = false
      })
    },
    loadVendorList () {
      this.showVendorList = true
      this.loadVendor()
    },
    cancelChanges () {
      this.lAction = 'view'
    },
    findVendor (curObject) {
      if (curObject.vendor_name) {
        var idx = this.vendors.findIndex(rec => rec.vendor_name === curObject.vendor_name)
        if (idx >= 0) {
          curObject.vendor_id = this.vendors[idx].vendor_id
        } else {
          curObject.vendor_id = null
          this.msg('Entered vendor is not found, it will be created newly', 2)
        }
      } else {
        curObject.vendor_id = null
      }
    },
    prepareUpdate (curAsset) {
      this.lAsset = Object.assign({}, curAsset)
      this.lAsset.asset_cat_pair = {asset_cat_id: this.lAsset.asset_cat_id, asset_cat: this.lAsset.asset_cat}
      this.lAsset.warranty_start_dt = curAsset.warranty_start_dt ? handy.formatDBDate(curAsset.warranty_start_dt) : null
      this.lAsset.warranty_end_dt = curAsset.warranty_end_dt ? handy.formatDBDate(curAsset.warranty_end_dt) : null
      this.lAsset.purchased_dt = curAsset.purchased_dt ? handy.formatDBDate(curAsset.purchased_dt) : null
      this.lAsset.amc_due_dt = curAsset.amc_due_dt ? handy.formatDBDate(curAsset.amc_due_dt) : null
      this.lAsset.amc_start_dt = curAsset.amc_start_dt ? handy.formatDBDate(curAsset.amc_start_dt) : null
      this.lAsset.next_service_due_dt = curAsset.next_service_due_dt ? handy.formatDBDate(curAsset.next_service_due_dt) : null
      this.lAsset.vendor_name = curAsset.vendor_id ? this.vendors.find(rec => rec.vendor_id === this.lAsset.vendor_id).vendor_name : ''
      this.loadVendor()
      this.loadCategory()
      this.lAction = 'update'
    },
    saveChanges (action) {
      if (!this.$refs.lForm.validate()) {
        return
      }
      if (!this.lAsset.asset_tag) {
        this.msg('Please insert asset tag', 0)
        return
      }
      this.beingSaved = true
      this.lAsset.asset_cat = this.lAsset.asset_cat_pair.asset_cat
      this.lAsset.asset_cat_id = this.lAsset.asset_cat_pair.asset_cat_id
      this.lAsset.is_under_warranty = this.lAsset.is_under_warranty ? this.lAsset.is_under_warranty : 'No'
      this.lAsset.is_under_amc = this.lAsset.is_under_amc ? this.lAsset.is_under_amc : 'No'
      if (!this.lAsset.vendor_id && this.lAsset.vendor_name) {
        // create vendor first before creating/updating asset
        this.axios.post(config.API_URL + '/vendor/create-vendor', {vendor_name: this.lAsset.vendor_name, comm_id: config.COMM_ID})
        .then(response => {
          this.lAsset.vendor_id = response.data
          this.loadVendor()
          this.axios.post(config.API_URL + '/asset/' + action, this.lAsset)
          .then(response => {
            // refresh the Asset list
            if (action === 'create') {
              this.lAsset.asset_id = response.data
              this.assetList.push(this.lAsset)
            } else {
              var idx = this.assetList.findIndex(asset => asset.asset_id === this.lAsset.asset_id)
              Object.assign(this.assetList[idx], this.lAsset)
            }
            this.lAction = 'view'
            this.beingSaved = false
          })
          .catch(err => {
            this.msg(err.response.data)
            this.beingSaved = false
          })
        })
        .catch(err => {
          this.msg(err.response.data)
          this.beingSaved = false
        })
      } else {
        // just create/update asset
        this.axios.post(config.API_URL + '/asset/' + action, this.lAsset)
        .then(response => {
          // refresh the Asset list
          if (action === 'create') {
            this.lAsset.asset_id = response.data
          } else {
            var idx = this.assetList.findIndex(asset => asset.asset_id === this.lAsset.asset_id)
            Object.assign(this.assetList[idx], this.lAsset)
          }
          this.searchAssets()
          this.msg('Saved successfully', 1)
          this.lAction = 'view'
          this.beingSaved = false
        })
        .catch(err => {
          this.msg(err.response.data)
          this.beingSaved = false
        })
      }
    },
    deleteAsset (curAsset) {
      if (!confirm('Sure, you want to delete the Asset with name "' + this.lAsset.asset_name + '"?')) {
        return
      }
      // up in db
      this.beingSaved = true
      this.axios.post(config.API_URL + '/asset/delete', curAsset)
      .then(response => {
        // refresh the list
        var idx = this.assetList.findIndex(asset => asset.asset_id === curAsset.asset_id)
        this.assetList.splice(idx, 1)
        this.lAction = 'view'
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err.response.data)
        this.beingSaved = false
      })
    },
    prepareCategory () {
      this.manageAssetCat = true
      this.lMAction = 'view'
    },
    createManageAsset () {
      this.lCat = {
        comm_id: config.COMM_ID,
        asset_cat: ''
      }
      this.lMAction = 'create'
    },
    prepareEdit (curCat) {
      this.lCat = Object.assign({}, curCat) // keep the original object safely before changes
      this.lMAction = 'update'
    },
    cancelChangesCat () {
      this.lMAction = 'view'
    },
    saveAssetCat () {
      // validate and save Changes
      if (this.$refs.acForm.validate()) {
        this.beingSaved = true
        this.axios.post(config.API_URL + '/assetCat/' + this.lMAction, this.lCat)
        .then(response => {
          // refresh the Category list
          if (this.lMAction === 'create') {
            this.lCat.asset_cat_id = response.data
            this.catList.push(this.lCat)
          } else {
            var idx = this.catList.findIndex(cat => cat.asset_cat_id === this.lCat.asset_cat_id)
            Object.assign(this.catList[idx], this.lCat)
          }
          this.lMAction = 'view'
          this.beingSaved = false
        })
        .catch(err => {
          this.msg(err.response.data)
          this.beingSaved = false
        })
      }
    },
    deleteCat (curCat) {
      if (!confirm('Sure, you want to delete the Category "' + curCat.asset_cat + '"?')) {
        return
      }
      this.beingSaved = true
      this.axios.post(config.API_URL + '/assetCat/delete', curCat)
      .then(response => {
        // refresh the list
        var idx = this.catList.findIndex(cat => cat.asset_cat_id === this.lCat.asset_cat_id)
        this.catList.splice(idx, 1)
        this.lMAction = 'view'
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err.response.data)
        this.beingSaved = false
      })
    },
    prepareHist (curHist) {
      this.lAsset = Object.assign({}, curHist)
      this.showHist = true
      this.lSHAction = 'view'
      this.loadServiceHist()
    },
    cancelChangesServHist () {
      this.lSHAction = 'view'
    },
    loadServiceHist () {
      var qry = {
        params: {
          asset_id: this.lAsset.asset_id
        }
      }
      // available Category
      this.axios.get(config.API_URL + '/getServiceHistByAssetId/', qry)
      .then(response => {
        this.histList = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    prepareCreateServiceHist () {
      this.lHist = {
        service_hist_dt: this.today,
        service_hist_desc: '',
        service_hist_cost: '',
        vendor_id: null,
        next_service_due_dt: null,
        asset_id: this.lAsset.asset_id,
        comm_id: config.COMM_ID
      }
      this.lSHAction = 'create'
    },
    saveServiceHistory (action) {
      if (!this.$refs.shForm.validate()) {
        return
      }
      this.beingSaved = true
      if (!this.lHist.vendor_id && this.lHist.vendor_name) {
        // create vendor first before creating/updating asset
        this.axios.post(config.API_URL + '/vendor/create-vendor', {vendor_name: this.lHist.vendor_name, comm_id: config.COMM_ID})
        .then(response => {
          this.lHist.vendor_id = response.data
          this.loadVendor()
          this.axios.post(config.API_URL + '/assetService/' + action, this.lHist)
          .then(response => {
            // refresh the Asset list
            if (action === 'create') {
              this.lHist.service_hist_id = response.data
              this.histList.push(this.lHist)
            } else {
              var idx = this.histList.findIndex(hist => hist.service_hist_id === this.lHist.service_hist_id)
              Object.assign(this.histList[idx], this.lHist)
            }
            this.lSHAction = 'view'
            this.beingSaved = false
          })
          .catch(err => {
            this.msg(err.response.data)
            this.beingSaved = false
          })
        })
        .catch(err => {
          this.msg(err.response.data)
          this.beingSaved = false
        })
      } else {
        this.axios.post(config.API_URL + '/assetService/' + action, this.lHist)
        .then(response => {
          // refresh the Asset list
          this.loadServiceHist()
          this.lSHAction = 'view'
          this.beingSaved = false
        })
        .catch(err => {
          this.msg(err.response.data)
          this.beingSaved = false
        })
      }
    },
    prepareEditHist (curAsset) {
      this.lHist = Object.assign({}, curAsset)
      this.lHist.service_hist_dt = handy.formatDBDate(curAsset.service_hist_dt)
      this.lHist.next_service_due_dt = curAsset.next_service_due_dt ? handy.formatDBDate(curAsset.next_service_due_dt) : null
      this.lHist.vendor_name = curAsset.vendor_id ? this.vendors.find(rec => rec.vendor_id === this.lHist.vendor_id).vendor_name : ''
      this.lSHAction = 'update'
    },
    deleteServiceHist (curHist) {
      if (!confirm('Sure, you want to delete the service histroy with date "' + curHist.service_hist_dt + '"?')) {
        return
      }
      this.beingSaved = true
      this.axios.post(config.API_URL + '/assetService/delete', curHist)
      .then(response => {
        // refresh the list
        var idx = this.histList.findIndex(hist => hist.service_hist_id === curHist.service_hist_id)
        this.histList.splice(idx, 1)
        this.lSHAction = 'view'
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err.response.data)
        this.beingSaved = false
      })
    },
    getEmptyConsumable () {
      var emptyConsumable = {
        comm_id: config.COMM_ID,
        cons_cat_id: '',
        cons_cat: '',
        cons_name: '',
        cons_uom: '',
        cons_stock: '',
        vendor_id: null
      }
      return emptyConsumable
    },
    prepareConsumable () {
      this.lCons = this.getEmptyConsumable()
      this.lAction = 'create-cons'
      this.loadVendor()
      this.loadConsCategory()
    },
    prepareConsCategory () {
      this.manageConsCat = true
      this.lConsAction = 'view'
    },
    loadConsCategory () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      // available Category
      this.axios.get(config.API_URL + '/getConsCategoryByCommId/', qry)
      .then(response => {
        this.consCatList = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    loadConsumable () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getConsListByCommId/', qry)
      .then(response => {
        this.consList = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    prepareUpdateconsumable (curCons) {
      this.lCons = Object.assign({}, curCons)
      this.lCons.cons_cat_pair = {cons_cat_id: this.lCons.cons_cat_id, cons_cat: this.lCons.cons_cat}
      this.lCons.vendor_name = curCons.vendor_id ? this.vendors.find(rec => rec.vendor_id === this.lCons.vendor_id).vendor_name : ''
      this.lAction = 'update-cons'
      this.loadConsCategory()
    },
    cancelChangesConsCat () {
      this.lConsAction = 'view'
    },
    createManageCons () {
      this.lConsCat = {
        comm_id: config.COMM_ID,
        cons_cat: ''
      }
      this.lConsAction = 'create'
    },
    saveConsCat (action) {
      if (this.$refs.ccForm.validate()) {
        this.beingSaved = true
        this.axios.post(config.API_URL + '/consCat/' + action, this.lConsCat)
        .then(response => {
          this.lConsCat.cons_cat_id = response.data
          // refresh the Category list
          if (action === 'create') {
            this.consCatList.push(this.lConsCat)
          } else {
            var idx = this.consCatList.findIndex(cat => cat.cons_cat_id === this.lConsCat.cons_cat_id)
            Object.assign(this.consCatList[idx], this.lConsCat)
          }
          this.lConsAction = 'view'
          this.beingSaved = false
        })
        .catch(err => {
          this.msg(err.response.data)
          this.beingSaved = false
        })
      }
    },
    deleteConsCat (curConsCat) {
      if (!confirm('Sure, you want to delete the Category "' + curConsCat.cons_cat + '"?')) {
        return
      }
      this.beingSaved = true
      this.axios.post(config.API_URL + '/consCat/delete', curConsCat)
      .then(response => {
        // refresh the list
        var idx = this.consCatList.findIndex(cons => cons.cons_cat_id === curConsCat.cons_cat_id)
        this.consCatList.splice(idx, 1)
        this.lConsAction = 'view'
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err.response.data)
        this.beingSaved = false
      })
    },
    saveChangesConsumable () {
      if (!this.$refs.cForm.validate()) {
        return
      }
      this.beingSaved = true
      var action = this.lAction === 'create-cons' ? 'create' : 'update'
      this.lCons.cons_cat_id = this.lCons.cons_cat_pair.cons_cat_id
      this.lCons.cons_cat = this.lCons.cons_cat_pair.cons_cat
      this.lCons.cons_stock_uom = this.lCons.cons_stock + ' ' + this.lCons.cons_uom
      if ((action === 'create' || action === 'update') && (!this.lCons.vendor_id && this.lCons.vendor_name)) {
        this.axios.post(config.API_URL + '/vendor/create-vendor', {vendor_name: this.lCons.vendor_name, comm_id: config.COMM_ID})
        .then(response => {
          this.lCons.vendor_id = response.data.vendor_id
          this.loadVendor()
          this.axios.post(config.API_URL + '/consumable/' + action, this.lCons)
          .then(response => {
            // refresh the Asset list
            if (action === 'create') {
              this.lCons.cons_id = response.data
              this.consList.push(this.lCons)
            } else {
              var idx = this.consList.findIndex(cat => cat.cons_id === this.lCons.cons_id)
              Object.assign(this.consList[idx], this.lCons)
            }
            this.lAction = 'view'
            this.beingSaved = false
          })
          .catch(err => {
            this.msg(err.response.data)
            this.beingSaved = false
          })
        })
      } else {
        this.axios.post(config.API_URL + '/consumable/' + action, this.lCons)
        .then(response => {
          // refresh the Asset list
          if (action === 'create') {
            this.lCons.cons_id = response.data
            this.consList.push(this.lCons)
          } else {
            var idx = this.consList.findIndex(cat => cat.cons_id === this.lCons.cons_id)
            Object.assign(this.consList[idx], this.lCons)
          }
          this.lAction = 'view'
          this.beingSaved = false
        })
        .catch(err => {
          this.msg(err.response.data)
          this.beingSaved = false
        })
      }
    },
    prepareConsEdit (curConsCat) {
      this.lConsCat = Object.assign({}, curConsCat) // keep the original object safely before changes
      this.lConsAction = 'update'
    },
    deleteCons (curCons) {
      if (!confirm('Sure, you want to delete the consumable with name "' + this.lCons.cons_name + '"?')) {
        return
      }
      // up in db
      this.beingSaved = true
      this.axios.post(config.API_URL + '/consumable/delete', curCons)
      .then(response => {
        // refresh the list
        var idx = this.consList.findIndex(cons => cons.cons_id === curCons.cons_id)
        this.consList.splice(idx, 1)
        this.lAction = 'view'
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err.response.data)
        this.beingSaved = false
      })
    },
    getEmptyStock () {
      var emptyStock = {
        cons_uom: this.lCons.cons_uom,
        cons_name: this.lCons.cons_name,
        cons_id: this.lCons.cons_id,
        stock_action: '',
        stock_qty: '',
        stock_desc: '',
        new_stock: '',
        purchase_or_cons_dt: this.today
      }
      return emptyStock
    },
    increaceStock (curStock) {
      this.lCons = Object.assign({}, curStock)
      this.lStock = this.getEmptyStock()
      this.lStock.stock_action = 'I'
      this.stockLabel = 'Purchase date'
      this.showStock = true
    },
    decreaseStock (curStock) {
      this.lCons = Object.assign({}, curStock)
      this.lStock = this.getEmptyStock()
      this.lStock.stock_action = 'D'
      this.stockLabel = 'Consumption date'
      this.showStock = true
    },
    cancelStockChanges () {
      this.showStock = false
    },
    saveStock () {
      if (this.$refs.stForm.validate()) {
        // preparation
        this.lStock.stock_dt = this.curTime
        this.lStock.new_stock = this.newStock
        this.lStock.old_stock = 0
        if (this.lStock.stock_action === 'I') {
          this.lStock.old_stock = Number(this.newStock) - Number(this.lStock.stock_qty)
        } else {
          this.lStock.old_stock = Number(this.newStock) + Number(this.lStock.stock_qty)
        }
        this.lStock.modify_by = config.USER_ID
        this.beingSaved = true
        this.axios.post(config.API_URL + '/stock/create', this.lStock)
        .then(response => {
          // refresh the consumable list
          var idx = this.consList.findIndex(cons => cons.cons_id === this.lStock.cons_id)
          this.lStock.cons_stock_uom = this.lStock.new_stock + ' ' + this.lCons.cons_uom
          this.lStock.cons_stock = this.lStock.new_stock
          Object.assign(this.consList[idx], this.lStock)
          this.beingSaved = false
          this.showStock = false
        })
        .catch(err => {
          this.msg(err)
          this.beingSaved = false
        })
      }
    },
    prepareConsumableReport (curConsumable) {
      this.consReport = Object.assign({}, curConsumable)
      if (!this.consReport.from_dt) {
        this.consReport.from_dt = handy.formatDBDate(new Date(new Date(this.today).getFullYear(), new Date(this.today).getMonth(), 1))
      }
      if (!this.consReport.to_dt) {
        this.consReport.to_dt = this.today
      }
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          cons_id: this.consReport.cons_id,
          from_dt: this.consReport.from_dt,
          to_dt: this.consReport.to_dt
        }
      }
      this.downloadConsReport = []
      this.consReport.netStock = 0
      this.axios.get(config.API_URL + '/getAllConsumableReport/', qry)
      .then(response => {
        this.consIds = []
        this.consIds = handy.unique(response.data.map(rec => rec.cons_id))

        var sno = 0
        var closingStock = 0
        this.consIds.forEach((consIdRec, j) => {
          this.consDet = []
          this.consDet = response.data.filter(rec => rec.cons_id === consIdRec)
          sno = 0
          this.consDet.forEach(rec => {
            this.downloadConsReport.push({
              sno: sno + 1,
              cons_name: rec.cons_name,
              purchase_or_cons_dt: rec.purchase_or_cons_dt,
              cust_name: rec.cust_name,
              modify_by: rec.modify_by,
              previous_stock: rec.previous_stock,
              pur_stock_qty: rec.stock_action === 'I' ? rec.stock_qty : '-',
              cons_stock_qty: rec.stock_action === 'D' ? rec.stock_qty : '-',
              cons_stock: rec.stock_action === 'I' ? Number(rec.previous_stock + rec.stock_qty) : rec.stock_action === 'D' ? Math.abs(Number(rec.previous_stock - rec.stock_qty)) : '',
              stock_desc: rec.stock_desc
            })
            // same as cons_stock update with in above push
            closingStock = rec.stock_action === 'I' ? Number(rec.previous_stock + rec.stock_qty) : rec.stock_action === 'D' ? Math.abs(Number(rec.previous_stock - rec.stock_qty)) : ''
          })
          // console.log(closing_stock)
          this.downloadConsReport.push({
            sno: 'Sub-Total',
            cons_name: 'Closing Stock',
            purchase_or_cons_dt: '-',
            cust_name: '',
            modify_by: 'Closing Stock',
            previous_stock: '',
            pur_stock_qty: '',
            cons_stock_qty: '',
            cons_stock: closingStock,
            stock_desc: ''
          })
          // if (response.data[response.data.length - 1].stock_action === 'I') {
          //   this.consReport.netStock = Number(response.data[response.data.length - 1].previous_stock + response.data[response.data.length - 1].stock_qty) + ' ' + response.data[response.data.length - 1].cons_uom
          // } else {
          //   this.consReport.netStock = Number(response.data[response.data.length - 1].previous_stock - response.data[response.data.length - 1].stock_qty) + ' ' + response.data[response.data.length - 1].cons_uom
          // }
          // console.log(this.consReport.netStock)
        })
        // console.log(this.downloadConsReport)
        this.showConsReport = true
      })
      .catch(err => {
        this.msg(err)
      })
    },
    prepareUpload () {
      this.lAction = 'upload'
    },
    prepareSerHistUpload () {
      this.lAction = 'upload-serviceHistory'
      this.lUpload.assetTypes = ['Critical']
      this.searchAssets()
    },
    validateServiceHistFile () {
      this.lAction = 'validate-serviceHistory'
      this.validateInProgress = true
      this.loadInProgress = true
      this.validFile = true
      this.headerIssue = false
      this.fileError = false
      this.totRecs = 0
      this.recSerHistLoaded = []
      this.totValid = 0
      this.totInvalid = 0
      this.totLoaded = 0
      this.totFail = 0
      // read file
      var file = this.$refs.ipFile.files[0]

      var reader = new FileReader()
      reader.onload = (e) => {
        var content = e.target.result

        // validate & show result
        var allLines = content.split(/\r\n|\n/)
        // ignore empty lines if any
        allLines = allLines.filter(rec => !rec.startsWith(',,,,'))
        this.totRecs = allLines.length - 1
        var headers = allLines[0].split(',')
        // 1. header & required columns
        for (var i = 0; i < this.reqSerHistHeaders.length; i++) {
          if (headers[i] !== this.reqSerHistHeaders[i]) {
            this.validateInProgress = false
            this.validFile = false
            this.headerIssue = true
            return
          }
        }
        // 2. validate each record
        var res = {}
        var curRec = ''
        for (var j = 1; j < allLines.length; j++) {
          if (allLines[j]) {
            curRec = allLines[j].split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/)
            res = {'error': ''}
            for (var c = 0; c < this.colSerHistNames.length; c++) {
              if (this.colSerHistNames[c].is_required && (curRec[c].trim() === '' || curRec[c].trim() === '""' || curRec[c].trim() === '""""')) {
                // special validation
                res['error'] += this.reqSerHistHeaders[c] + ' is empty; '
              } else {
                res[this.colSerHistNames[c].col_name] = curRec[c] && curRec[c].indexOf('"') >= 0 ? curRec[c].split('"').join('') : curRec[c]
              }
            }
            this.recSerHistLoaded.push(res)
            if (res['error']) {
              this.totInvalid++
            } else {
              this.totValid++
            }
          }
        }
        if (this.totInvalid) {
          this.validFile = false
        }
        this.validateInProgress = false
      }
      reader.readAsText(file)
    },
    async uploadAssetServiceHist () {
      // create service history List one by one
      this.readyForLoad = true
      this.loadInProgress = true
      this.beingSaved = true
      var curRec = ''
      var tmpDt = null
      for (var i = 0; i < this.recSerHistLoaded.length; i++) {
        curRec = this.recSerHistLoaded[i]
        if (!this.recSerHistLoaded[i].error) { // process only valid records
          // fill-in gaps
          this.recSerHistLoaded[i].comm_id = config.COMM_ID
          if (curRec.service_hist_dt) {
            tmpDt = curRec.service_hist_dt.split('-')
            curRec.service_hist_dt = handy.formatDBDate(new Date(tmpDt[2], tmpDt[1] - 1, tmpDt[0]))
          } else {
            curRec.service_hist_dt = null
          }
          if (curRec.next_service_due_dt) {
            tmpDt = curRec.next_service_due_dt.split('-')
            curRec.next_service_due_dt = handy.formatDBDate(new Date(tmpDt[2], tmpDt[1] - 1, tmpDt[0]))
          } else {
            curRec.next_service_due_dt = null
          }
          if (!curRec.service_hist_cost) {
            curRec.service_hist_cost = null
          }
          if (!curRec.vendor_id) {
            curRec.vendor_id = null
          }
          // create record
          await this.axios.post(config.API_URL + '/assetService/create', this.recSerHistLoaded[i])
          .then(response => {
            curRec.service_hist_id = response.data
            curRec.load_status = 'Loaded'
            this.totLoaded++
          })
          .catch(err => {
            curRec.error = err.response.data
            curRec.load_status = 'Failed'
            this.totFail++
          })
        }
      } // for every record
      if (!this.totFail) {
        this.msg('Uploaded successfully', 1)
        this.lAction = 'view'
      }
      this.loadInProgress = false
      this.beingSaved = false
    },
    promptUpload () {
      this.$refs.ipFile.click()
    },
    validateFile () {
      this.lAction = 'validate'
      this.validateInProgress = true
      this.loadInProgress = true
      this.validFile = true
      this.headerIssue = false
      this.fileError = false
      this.totRecs = 0
      this.recsLoaded = []
      this.totValid = 0
      this.totInvalid = 0
      this.totLoaded = 0
      this.totFail = 0
      // read file
      var file = this.$refs.ipFile.files[0]

      var reader = new FileReader()
      reader.onload = (e) => {
        var content = e.target.result

        // validate & show result
        var allLines = content.split(/\r\n|\n/)
        // ignore empty lines if any
        allLines = allLines.filter(rec => !rec.startsWith(',,,,'))
        this.totRecs = allLines.length - 1
        var headers = allLines[0].split(',')
        // 1. header & required columns
        for (var i = 0; i < this.reqHeaders.length; i++) {
          if (headers[i] !== this.reqHeaders[i]) {
            this.validateInProgress = false
            this.validFile = false
            this.headerIssue = true
            return
          }
        }
        // 2. validate each record
        var res = {}
        var curRec = []
        for (var j = 1; j < allLines.length; j++) {
          if (allLines[j]) {
            curRec = allLines[j].split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/)
            res = {'error': ''}
            for (var c = 0; c < this.colNames.length; c++) {
              if (this.colNames[c].is_required && curRec[c].trim() === '') {
                // special validation
                res['error'] += this.reqHeaders[c] + ' is empty; '
              } else {
                res[this.colNames[c].col_name] = curRec[c] && curRec[c].indexOf('"') >= 0 ? curRec[c].split('"').join('') : curRec[c]
              }
              if (res['asset_value'] === '') {
                res['asset_value'] = null
              }
            }
            this.recsLoaded.push(res)
            if (res['error']) {
              this.totInvalid++
            } else {
              this.totValid++
            }
          }
        }
        if (this.totInvalid) {
          this.validFile = false
        }
        this.validateInProgress = false
      }
      reader.readAsText(file)
    },
    showError (err) {
      this.msg(err, 2)
    },
    async uploadAsset () {
      // create asset List one by one
      this.readyForLoad = true
      this.loadInProgress = true
      this.beingSaved = true
      var curRec = ''
      var tmpDt = null
      for (var i = 0; i < this.recsLoaded.length; i++) {
        curRec = this.recsLoaded[i]
        if (!this.recsLoaded[i].error) { // process only valid records
          // fill-in gaps
          this.recsLoaded[i].comm_id = config.COMM_ID
          this.recsLoaded[i].comm_name = config.COMM_NAME
          if (curRec.purchased_dt) {
            tmpDt = curRec.purchased_dt.split('-')
            curRec.purchased_dt = handy.formatDBDate(new Date(tmpDt[2], tmpDt[1] - 1, tmpDt[0]))
          } else {
            curRec.purchased_dt = null
          }
          if (curRec.warranty_start_dt) {
            tmpDt = curRec.warranty_start_dt.split('-')
            curRec.warranty_start_dt = handy.formatDBDate(new Date(tmpDt[2], tmpDt[1] - 1, tmpDt[0]))
          } else {
            curRec.warranty_start_dt = null
          }
          if (curRec.warranty_end_dt) {
            tmpDt = curRec.warranty_end_dt.split('-')
            curRec.warranty_end_dt = handy.formatDBDate(new Date(tmpDt[2], tmpDt[1] - 1, tmpDt[0]))
          } else {
            curRec.warranty_end_dt = null
          }
          if (curRec.amc_start_dt) {
            tmpDt = curRec.amc_start_dt.split('-')
            curRec.amc_start_dt = handy.formatDBDate(new Date(tmpDt[2], tmpDt[1] - 1, tmpDt[0]))
          } else {
            curRec.amc_start_dt = null
          }
          if (curRec.amc_due_dt) {
            tmpDt = curRec.amc_due_dt.split('-')
            curRec.amc_due_dt = handy.formatDBDate(new Date(tmpDt[2], tmpDt[1] - 1, tmpDt[0]))
          } else {
            curRec.amc_due_dt = null
          }
          if (curRec.next_service_due_dt) {
            tmpDt = curRec.next_service_due_dt.split('-')
            curRec.next_service_due_dt = handy.formatDBDate(new Date(tmpDt[2], tmpDt[1] - 1, tmpDt[0]))
          } else {
            curRec.next_service_due_dt = null
          }
          if (curRec.is_critical === 'yes' || curRec.is_critical === 'Yes') {
            curRec.is_critical = true
          } else {
            curRec.is_critical = false
          }
          // create record
          await this.axios.post(config.API_URL + '/uploadAsset/create', this.recsLoaded[i])
          .then(response => {
            curRec.load_status = 'Loaded'
            this.totLoaded++
          })
          .catch(err => {
            curRec.error = err.response.data
            curRec.load_status = 'Failed'
            this.totFail++
          })
        }
      } // for every record
      if (!this.totFail) {
        this.msg('Uploaded successfully', 1)
        this.loadCategory()
        this.loadVendor()
        this.lAction = 'view'
      }
      this.loadInProgress = false
      this.beingSaved = false
    },
    clear () {
      this.lSearch = {
        asset_name: '',
        asset_tag: '',
        asset_cat_list: [],
        asset_location_list: [],
        amc: [],
        warranty: [],
        is_critical: false,
        non_critical: false
      }
    },
    loadAssetLocation () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getAssetLocationByCommId/', qry)
      .then(response => {
        this.assetLocation = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    }
  }
}
</script>

<style>
.my-label-text-size .v-label {
  font-size: 14px !important;
}
</style>



// WEBPACK FOOTER //
// Inventory.vue?54e8d7b0